import * as React from 'react';

export class ProgramTimingsLabel extends React.PureComponent {
  render() {
    return <div className="programstiminglayer-label-container aligned">Programs Timing</div>;
  }
}
